<div [class.card]="card()">
  <p>Coming soon!</p>
</div>
